// ------------------------------------
// EXIBIÇÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Elementos
    const $section = $('#produto');

    // Oculta/Exibe a seção
    function changeSecShow() {
      const value = confTheme[ref2]['produto-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
      produtoDestroySlick();
      if (value == '1') {
        produtoInitSlick();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeSecShow);
  }
})();

// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Elementos
    const $section = $('#produto');

    // Altera o tipo de fundo
    function changeBgType() {
      const value = confTheme[ref2]['bg-type'];
      if (value == 'image') {
        changeBgImage();
      } else if (value == 'gradient') {
        changeBgGradient();
      } else if (value == 'color') {
        changeBgColor();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'bg-type', changeBgType);

    // Altera a imagem de fundo
    function changeBgImage() {
      const image = confTheme[ref2]['bg-image'];
      $section.css('background-image', 'url(' + image + ')');
    }
    $root.on(refEvtPrefix + 'bg-image', changeBgImage);

    // Altera o gradiente de fundo
    function changeBgGradient() {
      const value = confTheme[ref2]['bg-gradient'];
      $section.css('background-image', value);
    }
    $root.on(refEvtPrefix + 'bg-gradient', changeBgGradient);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['produto-bg-color'];
      $section.css('background-image', 'none');
      if ($section.length > 0) {
        $section[0].style.setProperty('--produto-bg-color', color);
      }
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);
  }
})();

// ------------------------------------
// CORES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Elementos
    const $section = $('#produto');

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['produto-tit-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--produto-tit-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'tit-color', changeTitColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['produto-txt-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--produto-txt-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-color', changeTxtColor);

    // Altera a cor do preço
    function changePriceColor() {
      const color = confTheme[ref]['preco-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--preco-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'preco-color', changePriceColor);
  }
})();

// ------------------------------------
// DESCRIÇÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Elementos
    const $section = $('#produto');
    const $descricao = $('.produto-desc');
    const $descTitle = $('.produto-desc-titulo');

    // Oculta/Exibe a descrição
    function changeDescShow() {
      const value = confTheme[ref2]['produto-desc-show'];
      value == '1' ? $descricao.removeClass('d-none') : $descricao.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'desc-show', changeDescShow);

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['produto-desc-titulo'];
      $descTitle.html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'desc-titulo', changeTitle);

    // Altera a cor do título
    function changeTitColor() {
      const color = confTheme[ref]['produto-desc-tit-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--produto-desc-tit-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'desc-tit-color', changeTitColor);

    // Altera a cor do texto
    function changeTextColor() {
      const color = confTheme[ref]['produto-desc-txt-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--produto-desc-txt-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'desc-txt-color', changeTextColor);

    // Altera a cor de destaque do texto
    function changeTxtAltColor() {
      const color = confTheme[ref]['txt-alt-color'];
      $section[0].style.setProperty('--txt-alt-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-alt-color', changeTxtAltColor);

    // Altera a cor de fundo do texto
    function changeTxtBgColor() {
      const color = confTheme[ref]['txt-bg-color'];
      $section[0].style.setProperty('--txt-bg-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'txt-bg-color', changeTxtBgColor);
  }
})();

// ------------------------------------
// DIVISOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Altera o divisor
    function changeDivider() {
      const value = confTheme[ref2]['divisor'];
      $('.produto .section-divider').addClass('d-none');
      if (value) {
        $('.produto .section-divider.' + value).removeClass('d-none');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor', changeDivider);

    // Altera a cor do divisor
    function changeDividerColor() {
      const color = confTheme[ref]['divisor-color'];
      if ($('#produto').length > 0) {
        $('#produto')[0].style.setProperty('--divisor-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor-color', changeDividerColor);
  }
})();

// ------------------------------------
// BOTÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Elementos
    const $secButton = $('.produto-det-btn');

    // Altera a classe do botão
    function changeBtnClass() {
      const value = confTheme[ref2]['btn-class'];
      const styleClass = confTheme['general'][value + '-style'];
      const AnimationClass = confTheme['general'][value + '-animation'];
      $secButton
        .find('.btn')
        .removeClass(btnClassesRem)
        .addClass(value + ' ' + styleClass + ' ' + AnimationClass);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-class', changeBtnClass);

    // Altera o texto do botão
    function changeBtnText() {
      const value = confTheme[ref2]['btn-text'];
      $secButton.find('.btn').text(value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'btn-text', changeBtnText);
  }
})();

// ------------------------------------
// OUTRAS OPÇÕES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Altera o destaque do preço
    function changePriceDest() {
      const value = confTheme[ref2]['preco-destaque'];
      $('.produto-det-preco-container')
        .removeClass('destaque-total destaque-parcelamento')
        .addClass('destaque-' + value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'preco-dest', changePriceDest);
  }
})();

// ------------------------------------
// TABELA DE MEDIDAS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-produto-';

    // Elementos
    const $linkModal = $('.produto-det-modal-medidas');
    const $modalMedidas = $('#modal-medidas');

    // Oculta/Exibe a opção
    function changeMedidasShow() {
      const value = confTheme[ref2]['medidas-show'];
      value == '1' ? $linkModal.removeClass('d-none') : $linkModal.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'medidas-show', changeMedidasShow);

    // Altera o título
    function changeTitle() {
      const value = confTheme[ref2]['medidas-titulo'];
      $linkModal.find('a').text(value);
      $modalMedidas.find('.modal-title').text(value);
      $modalMedidas.find('.img img').attr('alt', value);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'medidas-titulo', changeTitle);

    // Altera a imagem
    function changeImage() {
      const image = confTheme[ref2]['medidas-src'];
      $modalMedidas.find('.img img').attr('src', image);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'medidas-src', changeImage);
  }
})();
